import "@assets/css/bootstrap-grid.css";
import React from "react";
import EnterpriseCherishMomentForm from "./cherish-moment.form";

const CherishMomentForm: React.FC = () => {
  return (
    <>
      <EnterpriseCherishMomentForm />
    </>
  );
};

export default CherishMomentForm;
